var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { StarIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../../../I18N";
import { Button } from "../../../../Components/UI/Button";



const DefaultButton = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: cell.row.original.default ? 'solid' : 'light',
  onClick: async () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, { className: "sr-only" }, void 0, "Default"), /*#__PURE__*/
_jsx(StarIcon, {
  className: `${
  !cell.row.original.default ?
  ' w-4 text-white stroke-current stroke-gray-300 stroke-2' :
  'w-4'}` }

)
);


const UninstallButton = ({ cell, column }) =>
!cell.row.original.default ? /*#__PURE__*/
_jsx(Button, {
  styling: "light",
  onClick: () => {var _column$columnDef$met3, _column$columnDef$met4;return (_column$columnDef$met3 = column.columnDef.meta) === null || _column$columnDef$met3 === void 0 ? void 0 : (_column$columnDef$met4 = _column$columnDef$met3.action) === null || _column$columnDef$met4 === void 0 ? void 0 : _column$columnDef$met4.call(_column$columnDef$met3, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Uninstall")
) : /*#__PURE__*/

React.createElement(React.Fragment, null, " ");


const ResetButton = ({ cell, column }) =>
cell.row.original.translationAvailable ? /*#__PURE__*/
_jsx(Button, {
  styling: "light",
  onClick: () => {var _column$columnDef$met5, _column$columnDef$met6;return (_column$columnDef$met5 = column.columnDef.meta) === null || _column$columnDef$met5 === void 0 ? void 0 : (_column$columnDef$met6 = _column$columnDef$met5.action) === null || _column$columnDef$met6 === void 0 ? void 0 : _column$columnDef$met6.call(_column$columnDef$met5, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Reset")
) : /*#__PURE__*/

React.createElement(React.Fragment, null, " ");


const LanguageLabel = ({ cell }) => /*#__PURE__*/
_jsx(Translate, {}, void 0, `${cell.row.original.label} (${cell.row.original.key})`);


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language");

const DefaultHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Default language");

const ResetHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Reset language");

const UninstallHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Uninstall language");

export {
  LanguageLabel,
  LabelHeader,
  DefaultHeader,
  UninstallHeader,
  DefaultButton,
  UninstallButton,
  ResetButton,
  ResetHeader };